import { Table } from 'reactstrap';
import { IFrenchTaskInfo } from '../../types/french';
import PaginationBar from '../common/pagination-bar';
import { useEffect, useRef, useState } from 'react';
import { ORG_VALUE_LISTS } from '../../graphql/valuelist-gql';
import { useApolloClient } from '@apollo/client';
import { IValueListLight } from '../../types/valuelist';
import { convertToLocalTime } from '../common/date-format';

const PAGE_SIZE = 10;

interface Column {
    label: string;
    accessor: keyof IFrenchTaskInfo;
    className?: string;
  }

interface SearchItemResultProp {
  catId: number,
  data: IFrenchTaskInfo[] | undefined;
  onSelect: (item: IFrenchTaskInfo | undefined) => void;
  selectChanged: boolean;
  startPage: number;
  refresh: boolean
}

const initialColumns: Column[] = [
  { label: "Field Data", accessor: "id"},
  { label: "Updated By", accessor: "updatedBy", className: 'colWidth15' },
  { label: "Date Updated", accessor: "dateUpdated", className: 'date-column date-column-iso' }
];

const historyColumns: Column[] = [
  { label: "Field Name", accessor: "id"},
  { label: "Date Updated", accessor: "dateUpdated", className: 'date-column date-column-iso' }
];

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

function FrenchItemList(props: SearchItemResultProp) {

  const {catId, data: items, onSelect: selectItem, selectChanged, startPage, refresh } = props;
  const [pagedData, setPagedData] = useState<IFrenchTaskInfo[]>([]);
  const [columns, setColumns] = useState(initialColumns);
  const [category, setCatetory] = useState<IValueListLight>()
  const client = useApolloClient()
  const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
  // keep a local copy of the selected item to prevent component repaints
  const [selectedItem, setSelectedItem] = useState<IFrenchTaskInfo | undefined>(sessionStorage.getItem("taskInfo")
    ? JSON.parse(sessionStorage.getItem("taskInfo")!)
    : undefined);

  useEffect(() => {
    if(sessionStorage.getItem("taskInfo")){
      setSelectedItem(JSON.parse(sessionStorage.getItem("taskInfo")!))
    }else
    setSelectedItem(undefined)
    for (const item of orgValueLists.frCategory) {
     // console.log("category code: " + item.code)
      if (item.id == catId && item.code == 'HISTORY') {
        setCatetory(item)
        setColumns(historyColumns)
      }else if(item.id == catId && item.code != 'HISTORY'){
        setCatetory(item)
        setColumns(initialColumns)
      }
    }
  }, [catId])

  useEffect(() => {
    setSelectedItem(undefined)
  },[refresh])

  function handleItemSelect(item : IFrenchTaskInfo | undefined) {
    selectItem(item);
    sessionStorage.setItem("taskInfo", JSON.stringify(item));
    setSelectedItem(item);
  }

  return (
    <>
      <Table id="french_queue_items" hover striped className="fixed">
        <thead>
          <tr>
            {columns.map(({ label, accessor, className }) => {
              return (
                <th scope="col" key={accessor} className={className ?? ''} >
                  {label}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {items && items.length>0
            ? pagedData.map((item, index) => {
              const isSelected = (item.entityId === selectedItem?.entityId && item.metaDataValueId === selectedItem?.metaDataValueId)

              return <tr key={item.id+'-'+index} className={isSelected ? 'table-primary' : 'pe-force action-link'} tabIndex={0}
                onClick={() => !isSelected && handleItemSelect(item)}
                onKeyUp={(e) => (e.key === 'Enter') && !isSelected && handleItemSelect(item)}>
                <td>
                {item.fieldValueEn}
                </td>
                {category?.code !='HISTORY' && <td className="colWidth15">{item.updatedBy}</td>}
                <td>{convertToLocalTime(item.dateUpdated, DATE_FORMAT)}</td>
              </tr>;
              })
            :<tr><td colSpan={columns.length} className="text-center">{selectChanged? 'Search results will appear in this table.' : 'No items were found.'}</td></tr>
          }
        </tbody>
      </Table>

      <PaginationBar data={items} pageSize={PAGE_SIZE} onPageChange={setPagedData} startPage={startPage} />
    </>
  )
}

export default FrenchItemList
